import React from 'react';
import PropTypes from 'prop-types';
import Switch from '@mui/material/Switch';
import { Chip, Tooltip } from '@mui/material';

const DataCard = ({
  title,
  cardData,
  onEdit,
  onToggle,
  width,
  headerActionTitle,
  headerAction,
}) => {
  /**
   * Render the toggle switch option if toggle is enabled
   *
   * @param {Object} item
   */
  const renderToggleSwitch = (item) => {
    return (
      <Switch
        checked={item.data}
        onChange={() => {
          onToggle(item.rawLabel, !item.data);
        }}
        color="primary"
      />
    );
  };

  /**
   * Render the value of the key-value pair if not toggle-able
   *
   * @param {Object} item
   */
  const renderDataValue = (item) => {
    return (
      <>
        {item.type === 'image' ? (
          <div
            className="image-container"
            style={{ backgroundImage: `url(${item.data})` }}
            onClick={() => {
              if (item.editable) {
                onEdit(item.rawLabel ? item.rawLabel : item.label);
              }
            }}
          />
        ) : item.type === 'external-link' ? (
          <a
            className={'data-card-row-data'}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.data}
          </a>
        ) : item.link ? (
          <a
            className={
              'data-card-row-data' +
              (item.editable ? 'active' : '') +
              (item.capitalized ? ' capitalized' : '')
            }
            href={`/${item.route}/${item.id}`}
            onClick={() => {
              if (item.editable) {
                onEdit(item.rawLabel ? item.rawLabel : item.label);
              }
            }}
          >
            {item.currency ? '$' : ''}
            {item.data}
          </a>
        ) : (
          <div
            className={
              'data-card-row-data' +
              (item.editable ? ' active' : '') +
              (item.capitalized ? ' capitalized' : '')
            }
            onClick={() => {
              if (item.editable) {
                onEdit(item.rawLabel ? item.rawLabel : item.label, item);
              }
            }}
          >
            {item.currency ? '$' : ''}
            {item.data}
            {item.paymentValidationOverridden && (
              <Tooltip title="Payment Validation Overridden" placement="top">
                <Chip size="small" label="Overridden" />
              </Tooltip>
            )}
          </div>
        )}
      </>
    );
  };

  return (
    <div className="data-card-details-container" style={{ width }}>
      <div className="data-card-details-header-container">
        <h1 className="data-card-details-header">{title}</h1>
        {headerActionTitle && (
          <h1 className="data-card-details-header-action" onClick={headerAction}>
            {headerActionTitle}
          </h1>
        )}
      </div>
      {cardData.map((item, index) => (
        <div className="data-card-row" key={`${item.label}-${index}`}>
          {item.label && <h1 className="data-card-row-label">{item.label}</h1>}
          {item.toggleable && renderToggleSwitch(item)}
          {!item.toggleable && renderDataValue(item)}
        </div>
      ))}
    </div>
  );
};

DataCard.propTypes = {
  title: PropTypes.string,
  cardData: PropTypes.arrayOf(PropTypes.shape({})),
  onEdit: PropTypes.func,
  onToggle: PropTypes.func,
  width: PropTypes.number,
  'cardData.map': PropTypes.func,
  headerActionTitle: PropTypes.string,
  headerAction: PropTypes.func,
};

export default DataCard;
